/* MATEO KADRIU — interactions v2 */

// ---------- Smooth scroll for in-page anchors only ----------
// (scroll-behavior: smooth removed from CSS to fix 2s scroll lock on load)
document.addEventListener('click', function(e) {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute('href');
  if (id === '#') return;
  const target = document.querySelector(id);
  if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
});

// ---------- Safari COOP fix — external link navigation ----------
// Safari blocks cross-origin navigation when the host page sends
// Cross-Origin-Opener-Policy headers (Shopify does). Using
// window.location.href bypasses the restriction entirely.
document.addEventListener('click', function(e) {
  const a = e.target.closest('a[href]');
  if (!a) return;
  const href = a.getAttribute('href');
  if (!href || href === '#' || href.startsWith('/') || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
  try {
    const url = new URL(href);
    if (url.hostname && url.hostname !== window.location.hostname) {
      e.preventDefault();
      window.location.href = href;
    }
  } catch (err) { /* not a valid URL, leave it alone */ }
});

// ---------- Drifting orbs (subtle parallax) ----------
// Only animates while something is moving, and not at all for "reduce motion"
(function orbs() {
  const els = document.querySelectorAll('.orb');
  if (!els.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let tx = 0, ty = 0, rx = 0, ry = 0, scrollY = window.scrollY, running = false;
  function loop() {
    rx += (tx - rx) * 0.05;
    ry += (ty - ry) * 0.05;
    els.forEach(o => {
      const depth = parseFloat(o.dataset.depth || '1');
      const x = rx * 30 * depth;
      const y = ry * 30 * depth + scrollY * 0.04 * depth;
      o.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    });
    if (Math.abs(tx - rx) < 0.001 && Math.abs(ty - ry) < 0.001) { running = false; return; }
    requestAnimationFrame(loop);
  }
  function kick() { if (!running && !document.hidden) { running = true; requestAnimationFrame(loop); } }
  window.addEventListener('mousemove', e => {
    tx = (e.clientX / window.innerWidth - 0.5);
    ty = (e.clientY / window.innerHeight - 0.5);
    kick();
  });
  window.addEventListener('scroll', () => { scrollY = window.scrollY; kick(); }, { passive: true });
  kick();
})();

// ---------- Magnetic buttons — removed, CSS handles hover ----------

// ---------- Reveal on scroll ----------
(function reveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();

// ---------- Sound feedback (toggleable, off by default) ----------
const SoundEngine = (function() {
  let ctx = null;
  let enabled = localStorage.getItem('mk_sound') === 'on';
  function ensure() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    return ctx;
  }
  function tick(freq = 600, dur = 0.04, vol = 0.04) {
    if (!enabled) return;
    const c = ensure();
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = 'sine';
    o.frequency.value = freq;
    g.gain.setValueAtTime(vol, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
    o.connect(g); g.connect(c.destination);
    o.start(); o.stop(c.currentTime + dur);
  }
  return {
    tick,
    toggle() { enabled = !enabled; localStorage.setItem('mk_sound', enabled ? 'on' : 'off'); return enabled; },
    isOn() { return enabled; }
  };
})();

document.addEventListener('mouseover', e => {
  const t = e.target.closest('a, button, .chip, .sticker, .blog-card');
  if (t && !t.dataset._ticked) {
    t.dataset._ticked = '1';
    SoundEngine.tick(700 + Math.random() * 200);
    setTimeout(() => delete t.dataset._ticked, 200);
  }
});

// ---------- Toast ----------
function toast(msg, ms = 2800) {
  const t = document.querySelector('.toast');
  if (!t) return;
  t.querySelector('.toast-text').textContent = msg;
  t.classList.add('show');
  clearTimeout(toast._t);
  toast._t = setTimeout(() => t.classList.remove('show'), ms);
}

// ---------- Konami easter egg ----------
(function konami() {
  const seq = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  let i = 0;
  document.addEventListener('keydown', e => {
    if (e.key.toLowerCase() === seq[i].toLowerCase()) {
      i++;
      if (i === seq.length) {
        i = 0;
        document.body.style.transition = 'filter 1.4s';
        document.body.style.filter = 'hue-rotate(40deg) saturate(1.3)';
        toast('🎛 Studio mode unlocked', 3500);
        setTimeout(() => document.body.style.filter = '', 5000);
      }
    } else { i = 0; }
  });
})();

// ---------- Sound toggle ----------
document.querySelectorAll('[data-sound-toggle]').forEach(btn => {
  btn.addEventListener('click', e => {
    const on = SoundEngine.toggle();
    const state = e.currentTarget.querySelector('.sound-state');
    if (state) state.textContent = on ? 'ON' : 'OFF';
    toast(on ? '🔊 Sound feedback enabled' : '🔇 Sound feedback off');
  });
});

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sound-toggle]').forEach(btn => {
    const state = btn.querySelector('.sound-state');
    if (state) state.textContent = SoundEngine.isOn() ? 'ON' : 'OFF';
  });
});

// ---------- Waveform ----------
(function wave() {
  document.querySelectorAll('.wave').forEach(wave => {
    if (wave.querySelector('.wave-bar')) return;
    for (let i = 0; i < 64; i++) {
      const b = document.createElement('div');
      b.className = 'wave-bar';
      if (i < 24) b.classList.add('active');
      wave.appendChild(b);
    }
    wave.querySelectorAll('.wave-bar').forEach((b, i) => {
      b.style.animationDelay = (i * 0.04) + 's';
      b.style.height = (10 + Math.random() * 70) + '%';
    });
  });
})();

// ---------- Welcome hint after 6s (only on devices with a keyboard) ----------
setTimeout(() => {
  const hasKeyboard = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (hasKeyboard && !sessionStorage.getItem('mk_hinted')) {
    sessionStorage.setItem('mk_hinted', '1');
    toast('💡 try ↑↑↓↓←→←→BA', 4500);
  }
}, 6500);

// ---------- Latest podcast episode date ----------
(function latestEpisode() {
  const labels = document.querySelectorAll('[data-episode-label]');
  if (!labels.length) return;
  const feed = 'https://podcasts.topalbaniaradio.com/feed/podcast/top-tech/';
  const timeout = new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 6000));
  Promise.race([fetch('https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(feed)), timeout])
    .then(r => r.json())
    .then(d => {
      const item = d && d.status === 'ok' && d.items && d.items[0];
      if (!item || !item.pubDate) return;
      const when = new Date(item.pubDate.replace(' ', 'T') + 'Z');
      if (isNaN(when)) return;
      const opts = { day: 'numeric', month: 'short' };
      if (when.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
      labels.forEach(l => { l.textContent = 'Latest episode · ' + when.toLocaleDateString('en-GB', opts); });
    })
    .catch(() => {});
})();
